import React, { useEffect } from "react";

import img1 from "../../assets/img/technologyinsidepic/cost.jpg";
import img2 from "../../assets/img/technologyinsidepic/security.jpg";
import img3 from "../../assets/img/technologyinsidepic/install.jpg";
import Aos from "aos";
import CardSingle from "../Services/Card/CardSingle";
import TextSingle from "../Services/TextCard/TextSingle";
import NormalText from "../Services/NormalText/NormalText";
import LifeSpan from "../Services/lifeSpan-Contact/Lifespan";
import { usePrismicDocumentByUID } from "@prismicio/react";

const Java = () => {
  const [document] = usePrismicDocumentByUID("services_webportal","javaid");
  const slice5 = document && document?.data;
  console.log(slice5);

  useEffect(() => {
    Aos.init();
    window.scrollTo(0, 0);
  }, []);
  const bg = {
    backgroundImage: `url(${slice5?slice5?.body[0].primary.bgimg1.url:"/java.png"})`,
    backgroundSize: "cover",
    backgroundPosition: "right",
  
    backgroundRepeat: " no-repeat",
  };
  const Textbg = {
    backgroundImage: `url(${slice5?slice5?.body[2].primary.bg_img.url:"/black1.jpg"})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  
    backgroundRepeat: " no-repeat",
  };
  const NormalTextbg = {
    backgroundSize: "cover",
    backgroundPosition: "cover",
    backgroundImage: `url(${slice5?slice5?.body[3].primary.listimage.url:"/bg1.jfif"})`,
    backgroundRepeat: " no-repeat",
    
  };
  const whiteColor = {
    color: "white",
  };
  return (
    <React.Fragment>
      <div className="webportal main-home mt-130 md-mt-60  " style={bg}>
        <div className="partition-bg-wrap">
          <div className="container">
            <div className="row">
              <div className=" col-lg-6 md-pl-14 mbl-mt-40">
                <div className="sec-title3 mb-40">
                  <h2
                    className="title white-color mb-16 Heading"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1800"
                    style={{ fontSize: "40px" }}
                  >
                     {slice5?slice5?.body[0].primary.tittle[0].text:"Java"}
                  </h2>
                  <p
                    className="desc white-color  md-pr-0 sub-text"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="3000"
                    style={{
                      fontSize: "15px",
                      lineHeight: " 1.4",
                      textAlign: "justify",
                    }}
                  >
                     {slice5?slice5?.body[0].primary.text1[0].text:"Java is a programming language that is widely used for building different types of software applications. It is a powerful and versatile language that is easy to learn, even for people new to programming.Java is class-based, object-oriented, and designed to have as few implementation dependencies as possible. This makes it an ideal language for building mobile apps, web applications, games, and other software."}
                    <br />
                    <br />
                    {slice5?slice5?.body[0].primary.text2[0].text:"One of the main advantages of Java is its 'Write once, run anywhere' (WORA) principle, which means that the code written in Java can run on any platform that supports Java, such as Windows, Mac, or Linux, without modification. This makes it a popular choice for enterprise applications and cross-platform development"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-ss main-home event-bg pt-50 pb-10 md-pt-30 md-pb-0"
        style={{ background: "#4f82c2" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-30"
              data-aos="zoom-out-right"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[0].cardimages.url:img1}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[0].tittle[0].text:"Cost-effective Development"}
                subtitle={slice5?slice5?.body[1].items[0].subtittle[0].text: "The application which is developed under Java is needed to test for every possible environment and browser. The user need not be oriented for any type of web browser and develop versions."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-30 mbl-mb-50 mbl-mt--40">
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[1].cardimages.url:img2}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[1].tittle[0].text:"Enhanced Security"}
                subtitle={slice5?slice5?.body[1].items[1].subtittle[0].text:"The applications are usually deployed on dedicated servers. They can be easily maintained and monitored by experienced server administrators. The potential security breaches of Java applications are comparatively tighter"}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30 mbl-mt--40"
              data-aos="zoom-out-left"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                textClass={whiteColor}
                image={slice5?slice5?.body[1].items[2].cardimages.url:img3}
                title={slice5?slice5?.body[1].items[2].tittle[0].text:"Easy to maintain and install"}
                subtitle={slice5?slice5?.body[1].items[2].subtittle[0].text:"we can easily install and maintain as the Java applications are web-based. If a new version is installed by the company the users can easily upgrade and feature easily. The new software can even be upgraded in the new versions."}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-Text main-home event-bg pt-10 pb-40 md-pt-10 md-pb-4 mbl-mb--40"
        style={Textbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-30 mbl-mt-30 mbl-mb-110"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[0].tittle[0].text:"Scalable and Reliable"}
                subtitle={slice5?slice5?.body[2].items[0].subtittle[0].text:" Java appears to be an all-round universal solution for every enterprise. So, it’s the fact that libraries are the basic structural units of any enterprise solution. You will find many loopholes in other programming languages, whereas, Java is able to tick the box on an issue way quicker and better."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-30 mbl-mt--130">
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[1].tittle[0].text:"Cross-platform Compatibility"}
                subtitle={slice5?slice5?.body[2].items[1].subtittle[0].text:"In the current time, many banks, retailers, manufacturers, insurance companies use Java for their app development. It's quite easy to understand and scalable language for both web and mobile application development as the Android platform is driven by Java."}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30 mbl-mt--70"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[2].tittle[0].text:"Simplicity"}
                subtitle={slice5?slice5?.body[2].items[2].subtittle[0].text:"The simplicity of Java is what attracts enterprises. It’s very easy and flexible to code in Java, while it also renders an easily understandable user interface for applications."}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="noraml-Text main-home event-bg pt-30 pb-80 md-pt-10 md-pb-300 mbl-pb-340"
        style={NormalTextbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-6 mb-30"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <NormalText
                itemClass="courses-item"
                title={slice5?slice5?.body[3].primary.tittle[0].text:"Key Features of Java:"}
                portalList="portal-none"
                ecommerce="ecommerce-none"
                twoList="twoList"
                cloudList=""
                listtwo="listtwo-none"
                listthree="listthree-none"
                list1={slice5?slice5?.body[3].items[0].lists[0].text:"Java is an object-oriented programming language, which means it is built around the concept of objects, classes and their interactions."}
                list2={slice5?slice5?.body[3].items[1].lists[0].text:"Java is an object-oriented programming language, which means it is built around the concept of objects, classes and their interactions."}
                list3={slice5?slice5?.body[3].items[2].lists[0].text:"Java has an automatic memory management feature which helps to reduce the chances of memory leaks and improve the overall performance of the application.               "}
                list4={slice5?slice5?.body[3].items[3].lists[0].text:"Java has a large developer community and a wide range of libraries and frameworks available, making it easy to find support and resources for development."}
                list5={slice5?slice5?.body[3].items[4].lists[0].text:"Java is a popular language among beginners because of its wide range of application such as Android, Web, Backend and many more."}
                list6={slice5?slice5?.body[3].items[5].lists[0].text:"Java is widely used in industry for developing different types of applications"}
                list13={slice5?slice5?.body[3].items[6].lists[0].text:"Java's new software can even be upgraded in the new versions."}
                
              />
            </div>
          </div>
        </div>
      </div>
      <LifeSpan />
    </React.Fragment>
  );
};

export default Java;
